import 'core-js/actual/object/values';
import 'core-js/actual/object/keys';
import 'core-js/actual/array/find';

import Vue from 'vue';
import throttle from 'lodash/throttle';
import Parallax from './components/Parallax';
import StockistsMap from './components/StockistsMap';
import SpinningBeer from './components/SpinningBeer';
import Swiper from 'swiper';

import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
gsap.registerPlugin(ScrollTrigger);

import Cookies from 'js-cookie';

new Vue({
	el: '#root',

	data: {
		mousemoveEvent: null,
		mouseoverEvent: null
	},

	methods: {
		mousemoveHandler(event) {
			this.mousemoveEvent = event
		},

		mouseoverHandler({ target }) {
			if (target.firstElementChild) {
				target.classList && target.classList.add('hovering');
			} else {
				target.parentNode.classList && target.parentNode.classList.add('hovering');
			}
			this.mouseoverEvent = event
		},

		mouseoutHandler({ target }) {
			window.setTimeout(() => {
				if (target.firstElementChild) {
					target.classList && target.classList.remove('hovering');
				} else {
					target.parentNode.classList.remove('hovering');
				}
			}, 500)
		}
	},

	mounted() {
		const root = this

		this.$el.addEventListener('mousemove', throttle(event => root.mousemoveHandler(event), 100))
	},

	components: {
		'parallax': Parallax,
		'stockists-map': StockistsMap,
		'spinning-beer': SpinningBeer
	}
});




/**
 * About - Awards swiper
 */
const awardsSwiper = new Swiper('.about-awards__swiper', {
  loop: false,
	slidesPerView: "auto",
	centeredSlides: true,

  pagination: {
    el: '.about-awards__ui .swiper-pagination',
		clickable: true
  },

  navigation: {
    nextEl: '.about-awards__ui .swiper-button-next',
    prevEl: '.about-awards__ui .swiper-button-prev',
  },
	
	breakpoints: {
    700: {
      slidesPerView: 2,
			slidesPerGroup: 2,
			centeredSlides: false
    },
    1000: {
      slidesPerView: 4,
			slidesPerGroup: 4,
			centeredSlides: false
    },
    1280: {
      slidesPerView: 5,
			slidesPerGroup: 5,
			centeredSlides: false
    },
  }
});




/**
 * Modal
 */
class AboutModal {
 	/**
 	 * Constructor
 	 *
 	 * @param openTrigger The element that will trigger opening the modal.
 	 * @param options Options that will override defaults.
 	 */
 	constructor(openTrigger, options) {
 		this.config = Object.assign({
 			modalTitle: '',
 			modalSubtitle: '',
			modalText: '',
			modalImage: '',
			modalClass: 'default',
 			// onBefore: null,
 			// onAfter: null
 		}, options);

 		// this.config.onBefore = this.config.onBefore.bind( this );
 		// this.config.onAfter = this.config.onAfter.bind( this );

 		this.openTrigger = openTrigger;

 		this.bindEvents();
 	}

 	// Bind events
 	bindEvents() {
 		this.openTrigger.addEventListener('click', this.open.bind(this));
 	}

 	// Open the modal
 	open() {
 		this.render();

 		this.modalDiv = document.getElementById('modal');
 		this.myModalContent = document.querySelector('.modal__inner');

 		this.modalDiv.addEventListener('click', this.close.bind(this));

 		if (this.config.onBefore) {
 			this.config.onBefore();
 		}

 		this.modalDiv.classList.add('is-open');
 		this.myModalContent.classList.add('animate-in');
		 
		document.body.classList.add('modal-is-open');

 		setTimeout(() => {
 			this.myModalContent.classList.remove('animate-in')
 		}, 200);
 	}

 	// Close the modal.
 	close(e) {

 		if (e.target.hasAttribute('data-close') && e.type === 'click') {
 			this.myModalContent.classList.add('animate-out');

 			// Remove classes
 			setTimeout(() => {

 				this.myModalContent.classList.remove('animate-out');
 				this.modalDiv.classList.remove('is-open');

 				this.containerDiv.parentNode.removeChild(this.containerDiv);
				 
				document.body.classList.remove('modal-is-open');

 				if (this.config.onAfter) {
 					this.config.onAfter();
 				}
 			}, 200);
 		}

 		return false;
 	}

 	// Render the modal.
 	render() {
 		const html = this.htmlTemplate();
 		const docFrag = document.createDocumentFragment();
 		this.containerDiv = document.createElement('div');
 		this.containerDiv.innerHTML = html;
 		document.body.appendChild(this.containerDiv);
 	}

 	// Modal HTML template.
 	htmlTemplate() {
		if (this.config.modalClass === 'team') {
			return `
				<div id="modal" class="modal modal--${this.config.modalClass}">
					<div class="modal__inner">
						<div class="modal__overlay" data-close></div>
						<div class="modal__content">
							<button class="modal__close" data-close><svg width="15" height="15" fill="currentColor" viewBox="0 0 15 15"><path d="M13.082 14.826l1.745-1.745-5.669-5.668 5.669-5.668L13.082 0 7.414 5.67 1.745 0 .001 1.744l5.669 5.67L0 13.081l1.744 1.744 5.669-5.669 5.668 5.669z"/></svg></button>
							<figure class="modal__image ${this.config.modalImage != 0 ? "has-image" : ""}">
								${this.config.modalImage != 0 ? `<img src="${this.config.modalImage}" alt="">` : ""}
							</figure>
							<div class="modal__text">
								<h3 class="title heading--block">${this.config.modalTitle}</h3>
								<div class="role">${this.config.modalSubtitle}</div>
								<div class="bio wysiwyg">${this.config.modalText}</div>
							</div>
						</div>
					</div>
				</div>
			`
		} else {
			return `
				<div id="modal" class="modal modal--${this.config.modalClass}">
					<div class="modal__inner">
						<div class="modal__overlay" data-close></div>
						<div class="modal__content">
							<button class="modal__close" data-close><svg width="15" height="15" fill="currentColor" viewBox="0 0 15 15"><path d="M13.082 14.826l1.745-1.745-5.669-5.668 5.669-5.668L13.082 0 7.414 5.67 1.745 0 .001 1.744l5.669 5.67L0 13.081l1.744 1.744 5.669-5.669 5.668 5.669z"/></svg></button>
							<div class="modal__text">${this.config.modalText}</div>
						</div>
					</div>
				</div>
			`
		}
 	}
	 
}


if (document.body.classList.contains('template--about')) {
	const teamModalTriggers = document.querySelectorAll('[data-team-modal-trigger]');
	const valuesModalTrigger = document.querySelector('[data-values-modal-trigger]');

	teamModalTriggers.forEach(function (trigger) {
		new AboutModal( trigger, {
			modalClass: 'team',
			modalTitle: trigger.querySelector('[data-name]').innerText,
			modalSubtitle: trigger.querySelector('[data-role]').innerText,
			modalText: trigger.querySelector('[data-text]').innerHTML,
			modalImage: trigger.dataset.fullImage
		} );
	});

	new AboutModal( valuesModalTrigger, {
		modalClass: 'values',
		modalText: document.getElementById('values-modal').innerHTML
	} );
}




/**
 * About - Gallery
 */
const initGalleries = () => {
	ScrollTrigger.matchMedia({
		"(min-width: 1025px)": function () {

			gsap.utils.toArray('.gallery-row').forEach((section, index) => {
				const items = section.querySelector('.gallery-row__items');
				// const [x, xEnd] = (index % 2) ? ['100%', (items.scrollWidth - section.offsetWidth) * -1] : [items.scrollWidth * -1, 0];
				const [x, xEnd] = (index % 2) ? [items.scrollWidth * 2, 0] : [items.scrollWidth * -1, 0];
				// const [x, xEnd] = [items.scrollWidth * -1, 0];
				gsap.fromTo(items, {
					x
				}, {
					x: xEnd,
					scrollTrigger: {
						trigger: section,
						scrub: 1,
						start: "top bottom+=50%",
						end: "bottom bottom-=25%",
					}
				});
			});

		}
	});
}



/**
 * Subscribe modal
 */
const subscribeModal = document.querySelector('[data-subscribe-modal]');
const subscribeModalCloseButton = document.querySelectorAll('[data-close-subscribe]');

if(Cookies.get('newsletterModal') != "closed") {
    subscribeModal.classList.add('is-open');
    document.body.classList.add('modal-is-open');
}

subscribeModalCloseButton.forEach(function (closeButton) {
    // need to set cookie here so we do not open modal again and again
    Cookies.set('newsletterModal', "closed")
	closeButton.addEventListener('click', function () {
		subscribeModal.classList.remove('is-open');
		document.body.classList.remove('modal-is-open');
	});
});

 
//FYI @martin document.body === document.getElementsByTagName("body")[0] === document.querySelector('body')

if (document.body.classList.contains('has-alert-banner')) {
	// we should only use let if we need to re-assign the value, use const otherwise
	const alertBannerClose = document.getElementById('alert-banner__close');
	const alertBanner = document.getElementById('alert-banner');
	const alertBannerHeight = alertBanner.clientHeight;  // check height on load
	
	document.body.style.marginTop = alertBannerHeight+'px';
	document.body.style.height = 'calc(100% - ' + alertBannerHeight+'px)';
	
	
	
	function closeBanner() {
		document.body.classList.remove('has-alert-banner');
		document.body.style.marginTop = 0;
		document.body.style.height = 100+'%';
		Cookies.set('alertbanner', "1");
	}
	// FYI, we don't want to override the onclick, as we don't know what else is there, safer to attach an event listener.
	// alertBannerClose.onclick = closeBanner;
	alertBannerClose.addEventListener('click', closeBanner);
} 

if (document.body.classList.contains('has-alert-banner')) {
	window.addEventListener('resize', getAlertBannerHeight);
	function getAlertBannerHeight() { // check height on resize
		const alertBannerHeight = alertBanner.clientHeight;
		document.body.style.marginTop = alertBannerHeight+'px';
		document.body.style.height = 'calc(100% - ' + alertBannerHeight+'px)';
	}
}




initGalleries();

